import { Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';
import { AssetTypes } from 'src/app/entities/enums/AssetTypes';
import { DynamicViewType } from '../../enums/DynamicViewType';

@Component({
  selector: 'app-misc-image-record-v2',
  templateUrl: './misc-image-record-v2.component.html',
  styleUrls: ['./misc-image-record-v2.component.sass']
})
export class MiscImageRecordV2Component implements OnInit {
  constructor(
    private clipboard: Clipboard,
    private messageService: MessageService,
  ) {}

  @Input() record: any;
  @Input() field: any;
  @Input() viewMode: 'record' | 'array';
  @Input() type: DynamicViewType;

  DynamicViewType = DynamicViewType;

  getAssetType(type: number): string {
    return AssetTypes[type] || 'Unknown';
  }

  isArray(): boolean {
    return this.viewMode === 'array';
  }
  
  isRecord(): boolean {
    return this.viewMode === 'record';
  }

  ngOnInit(): void {
    if (this.viewMode === 'array' && !Array.isArray(this.record[this.field.key])) {
      console.error(`Expected an array for the key ${this.field.key}`);
    }
  }

  copyPath(asset: any): void {
    const path = asset?.path || '';
    if (!path) return;
    this.clipboard.copy(path);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Path copied to clipboard.' });
  }

  copyAssetInfo(asset: any): void {
    const name = asset?.name || '';
    const id = asset?.id ?? '';
    const fileName = asset?.fileName || asset?.path?.split('/').pop() || asset?.path || '';
    const text = `${name}, ID: ${id}, ${fileName}`.trim();
    if (!text || text === ', ID: ,') return;
    this.clipboard.copy(text);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: text });
  }
}

